import { FC, useCallback, useEffect } from 'react'
import { Grid, Typography } from '../../../../../../../UI'
import useStyles from '../../../styles'
import {
  getApprovalStep,
  getApprovalValues,
  getContactInEstimate,
  getContractType,
  getDocusignEnv,
  getEstimate,
  getEstimateItems,
  getUser,
  getUserPrimaryEmail,
} from '../../../../../../../../ducks/selectors'
import { useStepperContext } from '../../../../../../../../hooks/useStepperContext'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'ducks/hooks'

import TOSDocumentSign from '../../../components/TOSDocumentSign'
import BottomButtons from '../../../components/BottomButtons'
import { configActions, estimateActions, estimateItemsActions } from 'ducks/actions'
import {
  APPROVAL_TYPE,
  companyRoles,
  CONTACT_ROLE,
  history,
  isEmpty,
  round,
  USER_TYPE,
} from 'helpers/index'
import { EstimateContact } from 'ducks/types'
import { EstimateType } from 'ducks/estimate/types'

const Step3Homeowner: FC = () => {
  const dispatch = useAppDispatch()
  const classes = useStyles()
  const { id: estimateId } = history.getParamValues()

  const { setShowWarnings, setCanGoForward } = useStepperContext()
  const user = useSelector(getUser)
  const estimateItems = useSelector(getEstimateItems(true))

  const fetchEstimateItems = useCallback(
    () => {
      dispatch(
        estimateItemsActions.fetchEstimateItems(
          estimateId,
          (_succ: boolean) => {
          }
        )
      )
    },
    [dispatch, estimateId]
  )

  useEffect(() => {
    fetchEstimateItems()
  }, [])

  const { paymentOption, isOverInstallmentThreshold, financingOption } =
    useSelector(getApprovalValues())

  const isBosscatFinancing = financingOption === 'Bosscat'
  const isHouseAmpFinancing = financingOption === 'HouseAmp'

  const push = history.usePushForward()

  const estimate = useSelector(getEstimate())
  const approvalStep = useSelector(getApprovalStep)

  const userFullName = `${user.firstName} ${user.lastName}`.trim()
  const userEmail = useSelector(getUserPrimaryEmail)

  const agentName = estimate?.properties.contacts?.find((contact) =>
    companyRoles.includes(contact.role as CONTACT_ROLE)
  )?.fullName
  const contactInEstimate = useSelector(getContactInEstimate(userEmail))
  const docusignEnv = getDocusignEnv()

  const docuSigned =
    (!isEmpty(contactInEstimate?.contractSignedOn?.toString()) &&
      estimate?.properties?.contractType === getContractType()) ||
    false

  const validation = !!docuSigned

  const isBelow10K = estimate?.properties?.totalWithTax && estimate?.properties?.installmentThreshold && estimate?.properties?.totalWithTax < estimate?.properties?.installmentThreshold


  const items = estimateItems?.map((item) => {
    const itemTitle = item.title.replaceAll("&", "%26").replaceAll("?", "%3F").replaceAll("=", "%3D")
    return `${itemTitle?.length > 55 ? `${itemTitle?.slice(0, 55)}...` : itemTitle
      } - Quantity: ${item?.quantity} - $${round(item?.totalPrice)}`
  })

  useEffect(() => {
    setShowWarnings(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setCanGoForward(validation)
  }, [validation])

  const sendApproval = () => {
    dispatch(
      configActions.setConfigValue({ type: 'overlayLoading', value: true })
    )
    const contacts: EstimateContact[] = estimate?.properties?.contacts?.reduce(
      (acc: any, curr: Partial<EstimateContact>) => {
        if (curr.email === userEmail) {
          acc = [
            ...acc,
            {
              ...curr,
              approvalType: APPROVAL_TYPE.APPROVED,
              isPayer: true,
            },
          ]
        } else {
          acc = [...acc, curr]
        }
        return acc
      },
      []
    )
    const payload: Partial<EstimateType> = {
      id: estimate?.id,
      properties: {
        address: estimate?.properties?.address,
        payAtClose: false,
        accessDetails: estimate?.properties?.accessDetails,
        preferredCompletedOn: estimate?.properties?.preferredCompletedOn,
        closingDate: estimate?.properties?.closingDate,
        contacts: contacts,
        userId: user?.id,
        clientNotes: estimate?.properties?.clientNotes,
        totalValue: estimate?.properties?.totalValue ?? 0,
        approvalStep: 0,
      },
    }
    dispatch(
      estimateActions.approval(
        payload,
        (success: boolean, status: string, payAtClose) => {
          dispatch(
            configActions.setConfigValue({
              type: 'overlayLoading',
              value: false,
            })
          )
          if (success) {
            push(`success`)
          }
        }
      )
    )
  }

  const submitStep = () => {
    // if (!isBelow10K && paymentOption === 'pay_at_close' && estimate?.properties.financingApprovedOn) {
    // }
    return sendApproval()
    // dispatch(
    //   estimateActions.updateEstimateByPath(
    //     [
    //       {
    //         op: 'replace',
    //         path: '/properties/approvalStep',
    //         value: approvalStep + 1,
    //       },
    //     ],
    //     (succ) => {
    //       dispatch(
    //         configActions.setConfigValue({
    //           type: 'overlayLoading',
    //           value: false,
    //         })
    //       )
    //     }
    //   )
    // )
  }

  const roleToShow = [USER_TYPE.BROKER, USER_TYPE.INSTITUTIONAL].includes(
    user.clientType
  )
    ? 'Real Estate Agent'
    : user.clientType

  return (
    <Grid className={classes.container} spacing={2}>
      {/* {paymentOption === 'pay_at_completion' && (
        <Grid
          container
          item
          className={classes.consent}
          style={{
            borderColor: '#99DDBD',
          }}
        >
          <Typography className={classes.consentText}>
            {` Please note, a ${estimate?.properties?.depositPercentage}% deposit is
          required on all projects.`}
          </Typography>
        </Grid>
      )} */}
      {/* {paymentOption === 'pay_at_close' && !isBelow10K && !isBosscatFinancing && !estimate?.properties.financingRejectedOn && ( */}
      <Grid
        container
        item
        className={classes.finalStep}
      >
        <Typography className={classes.finalStepTextBold}>
          {`ℹ️  Final Step:`}
        </Typography>
        <Typography className={classes.finalStepText}>{` Please sign the service agreement for your project.`}</Typography>
      </Grid>
      {/* )} */}
      <TOSDocumentSign
        onSuccess={submitStep}
        title="📋 Service Agreement"
        docuSignUrl={`${docusignEnv}&EnvelopeField_EstimateId=${estimate?.id}&Signer_UserName=${userFullName}&Signer_Email=${encodeURIComponent(userEmail)}&Fee=${round(estimate?.properties.totalWithTax || 0, 2)}&UserName=${userFullName}&UserTitle=${roleToShow}&EstimateRefId=${estimate?.properties.publicId}&AgentName=${agentName || ''}&AgentLicenseNumber=${user?.narId || '-'}&FullAddress=${estimate?.properties.fullAddress}&AddressLine1=${estimate?.properties?.address?.line_1 || estimate?.properties?.address?.line1}&AddressLine2=${(estimate?.properties.address?.line_2 || estimate?.properties.address?.line2) ? estimate?.properties.address?.line_2 || estimate?.properties.address?.line2 : `${estimate?.properties.address?.city}, ${estimate?.properties.address?.state} ${estimate?.properties.address?.zipCode}`}${estimate?.properties.address?.line_2 ? `&AddressLine3=${estimate?.properties.address?.city}, ${estimate?.properties.address?.state} ${estimate?.properties.address?.zipCode}` : ''}&Items1=${items.join(`%0A`)}`}
        docuSigned={docuSigned}
      />
      <BottomButtons
        buttonBack={{
          title: 'Back',
          action: () => {
            dispatch(
              configActions.setConfigValue({
                type: 'overlayLoading',
                value: true,
              })
            )

            dispatch(
              estimateActions.updateEstimateProperties(
                {
                  approvalStep: approvalStep - 1,
                },
                (succ) => {
                  dispatch(
                    configActions.setConfigValue({
                      type: 'overlayLoading',
                      value: false,
                    })
                  )
                }
              )
            )
          },
          // disable: true,
        }}
        buttonNext={{
          title: 'Schedule My Project!',
          action: submitStep,
          disable: !validation,
        }}
        showNextButton={docuSigned}
      />
    </Grid>
  )
}

export default Step3Homeowner
